import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { toast } from 'sonner';
import { Envelope, Lock, ShieldCheck } from '@phosphor-icons/react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL + '/api';

export const AdminLoginPage = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/admin/login`, formData);
      const { token, admin_id } = response.data;
      
      localStorage.setItem('admin_token', token);
      localStorage.setItem('user_role', 'admin');
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      toast.success('Admin login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Admin login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAFAFA] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="bg-orange-50 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
            <ShieldCheck className="h-8 w-8 text-[#FF5A36]" weight="duotone" />
          </div>
          <h1 className="font-['Chivo'] text-4xl font-black tracking-tighter text-[#121212] mb-2">
            Admin Access
          </h1>
          <p className="text-[#6B7280] font-medium">Designbiz.in Platform</p>
        </div>

        <Card className="border-[#E5E7EB] shadow-sm" data-testid="admin-login-card">
          <CardHeader>
            <CardTitle className="font-['Chivo'] text-2xl font-bold tracking-tight">
              Super Admin Login
            </CardTitle>
            <CardDescription>
              Access the admin dashboard
            </CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email" className="text-sm font-medium">Email</Label>
                <div className="relative">
                  <Envelope className="absolute left-3 top-3 h-4 w-4 text-[#6B7280]" weight="duotone" />
                  <Input
                    id="email"
                    data-testid="admin-email-input"
                    type="email"
                    placeholder="admin@designbiz.in"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="pl-10"
                    required
                  />
                </div>
              </div>

              <div className="space-y-2">
                <Label htmlFor="password" className="text-sm font-medium">Password</Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-3 h-4 w-4 text-[#6B7280]" weight="duotone" />
                  <Input
                    id="password"
                    data-testid="admin-password-input"
                    type="password"
                    placeholder="••••••••"
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    className="pl-10"
                    required
                  />
                </div>
              </div>

              <Button
                type="submit"
                data-testid="admin-login-button"
                className="w-full bg-[#FF5A36] hover:bg-[#E04828] text-white font-medium rounded-full"
                disabled={loading}
              >
                {loading ? 'Please wait...' : 'Login as Admin'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminLoginPage;
